import { Component, OnInit, Inject, Injector } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { takeUntil } from 'rxjs/operators';

import { DictionaryService } from '../../../services/dictionary.service';
import { LanguageService } from '../../../services/language.service';
import { DicEntryTranslationDto } from '../../../models/dic-entry-translation-dto.model';
import { FuncBaseDirective } from '../../../base/func-base/func-base';

@Component({
  selector: 'app-translate-dialog',
  templateUrl: './translate-dialog.component.html',
  styleUrls: ['./translate-dialog.component.scss'],
})
export class TranslateDialogComponent
  extends FuncBaseDirective
  implements OnInit
{
  languages = [];
  firstLanId = 1;
  firstLanText: string;
  secondLanId = 2;
  secondLanText: string;

  dtbShort;

  entry: DicEntryTranslationDto = null;

  constructor(
    injector: Injector,
    @Inject(MAT_DIALOG_DATA) data,
    private dialogRef: MatDialogRef<TranslateDialogComponent>,
    private dicService: DictionaryService,
    private langService: LanguageService
  ) {
    super(injector, 'Translate');

    this.dtbShort = data.dtbShort;
  }

  ngOnInit(): void {
    this.loadData();
  }

  private loadData() {
    this.langService
      .getLanguages(true, true)
      .subscribe((lang) => {
        this.languages = [];
        for (const i of lang) {
          this.languages.push({ id: i.id, text: i.text });
        }

        this.firstLanText = this.languages.find(
          (x) => x.id == this.firstLanId
        ).text;
        this.secondLanText = this.languages.find(
          (x) => x.id == this.secondLanId
        ).text;

        this.dicService
          .getTranslationForEntry(
            this.firstLanId,
            this.secondLanId,
            this.dtbShort
          )
          .subscribe((data) => {
            this.entry = data;
          });
      });
  }

  private refreshRow(entryId: number) {
    this.dicService
      .getEntryWithTranslation(this.firstLanId, this.secondLanId, entryId)
      .subscribe((r) => {
        if (this.dtbShort.id == entryId) {
          this.entry = r;
        }
      });
  }

  firstLanguageChanged(event) {
    this.firstLanId = event;
    this.loadData();
  }

  secondLanguageChanged(event) {
    this.secondLanId = event;
    this.loadData();
  }

  private addEntryTranslation(
    entryId: number,
    langId: number,
    translation: string
  ) {
    this.dicService
      .addEntryTranslation(entryId, langId, translation, false)
      .subscribe((r) => {
        this.snackBar.showDurationSnackbar(r);
        this.refreshRow(entryId);
      });
  }

  private editEntryTranslation(
    entryId: number,
    translationId: number,
    translation: string
  ) {
    this.dicService
      .editEntryTranslation(translationId, translation)
      .subscribe((r) => {
        this.snackBar.showDurationSnackbar(r);
        this.refreshRow(entryId);
      });
  }

  private deleteEntryTranslation(entryId: number, translationId: number) {
    this.dicService
      .deleteEntryTranslation(translationId)
      .subscribe((r) => {
        this.snackBar.showDurationSnackbar(r);
        this.refreshRow(entryId);
      });
  }

  private saveEntryTranslation(
    entryId: number,
    langId: number,
    entryTranslationId: number,
    fs: string
  ) {
    const idToFind = `${entryId}.${entryTranslationId}.${fs}`;
    const newText = (document.getElementById(idToFind) as HTMLInputElement)
      .value;

    if (entryTranslationId == null && (newText != null || newText != '')) {
      this.addEntryTranslation(entryId, langId, newText);
    } else if (entryTranslationId != null && newText != null && newText != '') {
      this.editEntryTranslation(entryId, entryTranslationId, newText);
    } else if (
      entryTranslationId != null &&
      (newText == null || newText == '')
    ) {
      this.deleteEntryTranslation(entryId, entryTranslationId);
    }
  }

  saveFirst(value: DicEntryTranslationDto) {
    this.saveEntryTranslation(
      value.id,
      this.firstLanId,
      value.first.id,
      'first'
    );
  }

  saveSecond(value: DicEntryTranslationDto) {
    this.saveEntryTranslation(
      value.id,
      this.secondLanId,
      value.second.id,
      'second'
    );
  }

  close() {
    this.dialogRef.close();
  }
}
